<template>
  <el-dialog title="工单信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height">

          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent"
                      show-overflow height="390" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">

              <template #form>

                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="工单号:" field="orderNo">
                    <template v-slot>
                      <el-input v-model="formData.orderNo" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="用户号码:" field="userMobile">
                    <template v-slot>
                      <el-input v-model="formData.userMobile" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                </vxe-form>

                <div class="clearfix screen-btns">
                  <div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
                    <!-- <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
                                status="primary" plain>重置</vxe-button> -->
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索</vxe-button>
                  </div>
                </div>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi'],
  mixins: [selectDialogMixins],
  components: { pager },

  created() {
    this.initSetting();

  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      columns: [
        { type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
        { title: '工单号', field: 'orderNo', width: 200, },
        { title: '服务类型', field: 'serviceTypeName', width: 110, },
        { title: '用户姓名', field: 'userName', width: 110, },
        { title: '用户手机', field: 'userMobile', width: 110, },
        { title: '档案号', field: 'profileNo', width: 200, },
        { title: '产品条码', field: 'barcode', width: 110, },
        { title: '产品名称', field: 'itemName', width: 110, },
        { title: '产品分类', field: 'bigCategoryName', width: 110, },
      ],
      total: 0,
      filterText: '',
      data: [],

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        orderNo: null,
        userMobile: null,
        searchFlag:0,
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      selectedRow: {
        orderId: null, orderNo: null
      }
    };
  },


  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },


    radioChangeEvent ({ row }) {
      this.selectedRow = {orderId: row.orderId, orderNo: row.orderNo, userName:row.userName, userMobile:row.userMobile,
        itemId:row.itemId, itemName:row.itemName, itemCode:row.itemCode,barcode:row.barcode,
        bigCategoryId:row.bigCategoryId, bigCategoryName:row.bigCategoryName,
        profileId:row.profileId,profileNo:row.profileNo,serviceTypeName:row.serviceTypeName,
        serviceTypeId: row.serviceTypeId,useStat:row.useStat
      }
    },


    commitRow() {
      console.log('选中的工单', this.selectedRow.itemId)
      if (this.selectedRow.orderNo !== null) {
        this.$emit('commit', this.selectedRow)
        this.dialogClose()
      } else {
        this.$message.warning('请先选中数据')
      }
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },


    // 搜索
    searchEvent() {
      this.formData.searchFlag = 1
      if(!this.formData.orderNo && !this.formData.userMobile){
        this.$message.error('请输入工单号或用户号码查询')
        return false;
      }

      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.formData.orderNo = ''
      this.formData.userMobile = ''
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.reloadTree()
    },


    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.wkAssetTransfer.getAssetOrderListPageUrl,
        param: this.formData,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: 100%;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}




::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}



::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
